import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSwitchairplane(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.406 9.432a1.81 1.81 0 0 1 1.588.17l2.78 1.752 2.864-1.043a5.1 5.1 0 0 1 3.496.005.68.68 0 0 1-.002 1.278L7.77 15.729a1 1 0 0 1-1.1-.288L4.85 13.32a.25.25 0 0 1 .104-.398l.571-.208a1.78 1.78 0 0 1 1.685.254l.366.277 2.254-.82-2.03-2.417-.024-.036-.019-.04a.25.25 0 0 1 .15-.32zm6.293 3.775-3.174 1.155zM12.032 1.47a.75.75 0 0 1 1.06 0l2.72 2.718a.75.75 0 0 1-.53 1.28H7.874a4.625 4.625 0 0 0-4.625 4.626.75.75 0 0 1-1.5 0 6.125 6.125 0 0 1 6.125-6.125h5.596L12.032 2.53a.75.75 0 0 1 0-1.06M21.5 13.156a.75.75 0 0 1 .75.75 6.125 6.125 0 0 1-6.125 6.125h-5.596l1.439 1.439a.75.75 0 1 1-1.06 1.06l-2.72-2.718a.75.75 0 0 1 .53-1.28h7.407a4.625 4.625 0 0 0 4.625-4.626.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }));
}
var IcSwitchairplane = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSwitchairplane));

export { IcSwitchairplane as I };
